import { differenceInBusinessDays, differenceInDays, eachDayOfInterval, eachWeekendOfYear, formatISO, getYear, isSameDay, isValid, isWeekend, isWithinInterval, startOfDay } from "date-fns";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function calendar_service_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else calendar_service_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
class Calendar {
    download(_0) {
        return _async_to_generator(function*(date = new Date(), id) {
            const year = getYear(date);
            const defaultYear = 2021;
            if (year < defaultYear) return;
            this.holidaysAndWeekends[year] = eachWeekendOfYear(date).reduce((acc, day)=>_object_spread_props(_object_spread({}, acc), {
                    [formatISO(day, {
                        representation: 'date'
                    })]: true
                }), {});
        }).apply(this, arguments);
    }
    downloadWorkSchedule(year, employeeId) {
        return _async_to_generator(function*() {
            return null;
        })();
    }
    formatISO(date, options = {
        representation: 'complete'
    }) {
        return formatISO(date, options);
    }
    isHolidayOrWeekend(date) {
        const year = getYear(date);
        if (this.holidaysAndWeekends[year]) return !!this.holidaysAndWeekends[year][formatISO(date, {
            representation: 'date'
        })];
        return isWeekend(date);
    }
    isHoliday(date) {
        const year = getYear(date);
        if (this.holidays[year]) return !!this.holidays[year][formatISO(date, {
            representation: 'date'
        })];
        return false;
    }
    isSameDay(date1, date2) {
        return isSameDay(date1, date2);
    }
    differenceInDays(date1, date2, options) {
        if (null == options ? void 0 : options.excludeHolidays) return differenceInDays(date1, date2) - this.countOfHolidaysInInterval(date2, date1);
        if (null == options ? void 0 : options.excludeWorkingDays) return differenceInBusinessDays(date1, date2);
        return differenceInDays(date1, date2);
    }
    startOfDay(date) {
        return startOfDay(date);
    }
    isWithinIntervals(date, intervals) {
        return intervals.some((interval)=>isWithinInterval(date, {
                start: interval[0],
                end: interval[1]
            }));
    }
    countOfHolidaysInInterval(date1, date2) {
        return eachDayOfInterval({
            start: date1 < date2 ? date1 : date2,
            end: date1 < date2 ? date2 : date1
        }).filter((day)=>this.isHoliday(day)).length;
    }
    isValidDate(date) {
        return isValid(date);
    }
    constructor(){
        this.holidaysAndWeekends = {};
        this.holidays = {};
    }
}
export { Calendar };
